<template>
  <div v-if="pageConfig" class="trial-page">
    <Forbid v-if="!hasPermission"></Forbid>
    <TemplatePreset
      v-else
      :agreementTip="agreementTip"
      :agreementType="pageConfig.agreement_type"
      :agreementTitles="agreements"
      :defaultSelectStatus="defaultSelectStatus"
      :stopScroll="isFinish"
      :isShowAgreementSelect="!isApplySuccess"
      :isBlueStyle="true"
      @initAgreements="handleInitAgreements"
      @agree-change="
        (agree) => {
          isAgree = agree;
        }
      "
    >
      <template v-slot:main class="trial">
        <!-- 首图 -->
        <ProxyImg v-if="pageConfig.header" :img="pageConfig.header"></ProxyImg>
        <div
          v-for="(item, index) in pageConfig.content"
          :id="index === 1 && hasMobileModule ? 'mobile-wrapper' : ''"
          :key="index"
          class="comp-wrapper"
        >
          <!-- 验证手机号功能模块 -->
          <valid-phone
            v-if="index === 1 && hasMobileModule"
            :isAgree="isAgree"
            :validPhone="pageConfig.mobile"
            :messageType="pageConfig.business_type"
            :btnColor="pageConfig.mobile_button_color"
            :bg="item.data[1]"
            :btnText="validPhoneText"
            @apply="handleApply"
            @valid-success="handleValidSucces"
            @get-code="handleGetCode"
          />

          <!-- 第二张图[]的第二项是手机号模块背景，只展示item.data[0] -->
          <!--  
            有四种类型：
            image: StaticImage,
            'flash-code': StaticCode,
            gif: StaticGif,
            swiper: StaticSwiper, -->
          <component
            :is="compMap[item.type]"
            ref="resList"
            :data="index === 1 ? [item.data[0]] : item.data"
            :productionId="productionId"
            @track-btn-click="$emit('track-btn-click', arguments[0])"
          ></component>
        </div>
      </template>
      <div v-show="!isShowMobileValid" slot="bottom" class="bottom-wrapper">
        <!-- 报名按钮，根据接口 user 渲染不同状态 -->
        <component
          :is="currentBottomComp"
          ref="bottom"
          :config="bottomConfig.config"
          :type="bottomConfig.type"
          :isAgree="isAgree"
          :isFinish="isFinish"
          :bgColor="pageConfig.button_color"
          @apply="handleApply"
          @go-url="handleGoUrl"
          @success-modal="handleOpenModal"
        ></component>
      </div>

      <!-- 支付方式模块 -->
      <template slot="container-absolute-item">
        <ChannelSwitch
          v-if="
            !pageConfig.payment_check &&
            canApply &&
            !isShowMobileValid &&
            !isFreePrice
          "
          :canSelect="supportType.length > 1"
          :config="payConfig"
          class="switch"
          @change="isShowPayChannel = true"
        ></ChannelSwitch>
        <ModalChannelSelect
          v-if="
            !pageConfig.payment_check &&
            canApply &&
            !isShowMobileValid &&
            !isFreePrice
          "
          :toggle="isShowPayChannel"
          :supportType="supportType"
          :useAbsolutePosition="true"
          :defaultType="defaultPayType"
          :huabeiList="huabeiList"
          :huabeiTotalAmount="huabeiTotalAmount"
          @change="onChangeChannel"
          @close="isShowPayChannel = false"
        ></ModalChannelSelect>
      </template>

      <!-- 已购买展示助教弹窗？ -->
      <template slot="fix-items">
        <PopupTipSuccess
          :textConfig="popupConfig"
          :isShow="isShowSuccessPopup"
          :closable="popupConfig.closable"
          @close="isShowSuccessPopup = false"
          @reloadQrcode="handleReloadQrcode"
          @longTouch="handlePostLongTouch"
        ></PopupTipSuccess>
      </template>
    </TemplatePreset>

    <!-- 问卷模块 -->
    <component
      :is="
        questionCompMap[pageConfig.survey_type || 'idp_class'] ||
        questionCompMap.idp_class
      "
      :isShow="isShowQuestionnaire"
      :surveyCode="questionSurveyCode"
      @refresh="onQuestionnaireFinish"
    />
    <!-- 取消支付展示优惠券？ -->
    <re-pay-modal
      :strategyData="strategyData"
      :show="showRepayModal"
      @cancel="onCloseRepay"
      @confirm="handleRepay"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import TemplatePreset from '@/modules/common/TemplatePreset.vue';
import StaticContent from '../../flashcode/components/StaticContent.vue';
import BottomApply from './components/Apply.vue';
import BottomProcess from '../../flashcode/components/Process.vue';
import { Route } from 'vue-router';
import PopupTipSuccess from '@/modules/common/PopupTipSuccess';
import ProxyImg from '@/modules/common/ProxyImg';
import Forbid from '../Forbid.vue';
import EnrollmentMixin from '../mixins/EnrollmentMixin';
import ScrollTracker from '@/lib/ScrollTracker';
import Closure2TrackerMixin from '../mixins/Closure2TrackerMixin';
import {
  IPayType,
  ModalChannelSelect,
  ChannelSwitch,
  allChannels,
  PayTypes,
} from '@/modules/common/MutiPayChannel';
import {
  IAgreement,
  IBottom,
  IPageConfig,
  IUserData,
  BottomType,
} from '../types';
import validPhone from '../components/ValidPhone.vue';
import RePayModal from '../components/StayStrategy/RePay.vue';

@Component({
  components: {
    TemplatePreset,
    StaticContent,
    BottomApply,
    PopupTipSuccess,
    ProxyImg,
    Forbid,
    ChannelSwitch,
    ModalChannelSelect,
    validPhone,
    RePayModal,
  },
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    window.Al.start();
    window.np.start();
    Promise.all([
      window.apis.getSingleInfo({
        ...to.params,
        ...to.query,
        production_id: to.params.id,
      }),
      window.apis.getSingleUser({
        ...to.params,
        ...to.query,
        production_id: to.params.id,
      }),
    ])
      .then(([productionRes, userRes]) => {
        if (productionRes.data.in_activity) {
          next((vm: Single) => {
            const query: Record<string, string> = {
              ...to.query,
              production_id: productionRes.data.production_id,
            };

            vm.$router.push({
              name: 'DoubleEleven2021',
              query,
            });
          });
        } else if (userRes.data && userRes.data.success_url) {
          next(() => {
            window.location.replace(userRes.data.success_url);
          });
        } else {
          next((vm: Single) => {
            vm.handleSetPageTitle(productionRes.data.index_title);
            vm.initResource(productionRes.data, userRes.data);
            window.Al.done();
            window.np.done();
          });
        }
      })
      .catch((e) => {
        console.log('init', e);
      });
  },
})
export default class Single extends Mixins(
  EnrollmentMixin,
  Closure2TrackerMixin
) {
  $refs!: {
    bottom: {
      handleUserAction: Function;
    };
    content: StaticContent;
    resList: any;
  };
  pageConfig: IPageConfig | null = null;
  isAgree = true;
  productionId = 0;
  bottomConfig: IBottom = {
    type: BottomType.APPLY,
    config: null,
  };
  isShowSuccessPopup = false;
  popupConfig: any = {};
  isForbidScroll = false;
  hasPermission = true;

  isShowPayChannel = false;
  payConfig: IPayType = allChannels['wechat'];

  supportType: PayTypes[] = [];
  defaultPayType: PayTypes = PayTypes.wechat;
  agreements: string[] = [];

  get currentBottomComp() {
    return this.bottomConfig.type === BottomType.APPLY
      ? BottomApply
      : BottomProcess;
  }
  get isFinish() {
    return this.bottomConfig.type === BottomType.FINISH;
  }
  get isApplySuccess() {
    return this.bottomConfig.type !== BottomType.APPLY && !this.isFinish;
  }
  get canApply() {
    return this.bottomConfig.type === BottomType.APPLY;
  }
  get agreementTip() {
    return `请阅读并勾选${this.agreements.join(' ')}`;
  }
  get defaultSelectStatus() {
    if (!this.canApply) {
      return true;
    }

    return this.pageConfig?.agreement_check || false;
  }

  mounted() {
    this.addEventListenerPopstate();
    setTimeout(() => {
      const ele = document.getElementById('t-scroll-container');
      if (ele) {
        new ScrollTracker((s, e) => {
          this.__trackScrollPageview(s, e);
        }, ele).register();
      }
    });
  }

  addEventListenerPopstate() {
    if (window.history && window.history.pushState) {
      window.history.pushState('forward', '', location.href);
      window.addEventListener('popstate', this.backChange, false);
    }
  }

  backChange() {
    // @ts-ignore
    window.history.forward(1);
  }

  initResource(data: IPageConfig, userData: IUserData) {
    if (data.redirect_url) {
      window.location.replace(data.redirect_url);
      return;
    }

    this.hasPermission = data.permission;
    this.productionId = data.production_id;

    // 初始化分享信息
    if (data && data.share) {
      const share = data.share;
      this.$initShare(() => {
        window.wx.ready(() => {
          window.wx.onMenuShareTimeline(share.timeline);
          window.wx.onMenuShareAppMessage(share.app_message);
        });
      });
    }

    // 无资格，展示无资格页面
    if (!this.hasPermission) {
      this.pageConfig = data;
      return;
    }

    this.initUser(userData);
    const config = userData.bottom.config;
    const payment_configs = data.payment_configs;
    if (payment_configs) {
      this.defaultPayType =
        data.default_payment || payment_configs[0] || PayTypes.wechat;
      this.payConfig = allChannels[this.defaultPayType];
      this.supportType = payment_configs;
    }

    this.pageConfig = data;
    this.handleTrack(); // 公共埋点
    this.handleTrackResList();
    this.handleObserverMobile();
    this.__closure2TrackerViewTracker(); // 0元落地页截流埋点
    this.initStrategyTracker(); // 截流1.1埋点
  }
  initUser(data: IUserData) {
    // 优惠券id？
    this.couponId = data.coupon_id;
    this.bottomConfig = data.bottom;

    if (!this.canApply) {
      this.handleRecordCoupon();
    }

    this.$nextTick(() => {
      if (this.bottomConfig.config!.show) {
        this.$refs.bottom.handleUserAction();
      }
    });
  }

  handleGoUrl(config: { url: string; button: string }) {
    this.__trackBtnLeave({
      button_name: config.button,
    });
    if (config.url) {
      setTimeout(() => {
        window.location.href = config.url;
      }, 300);
    }
  }
  handleOpenModal(config: { modal: any }) {
    this.popupConfig = config.modal;
    this.isShowSuccessPopup = true;
  }

  freshBottomConfig() {
    return window.apis
      .getSingleUser({
        ...this.$route.params,
        ...this.$route.query,
        production_id: this.$route.params.id,
      })
      .then((res: any) => {
        if (res.data && res.data.success_url) {
          window.location.replace(res.data.success_url);
        } else {
          this.initUser(res.data);
        }
      })
      .catch((e: any) => {
        console.log('freshBottomConfig', e);
      });
  }

  handleInitAgreements(res: IAgreement[]) {
    if (res.length) {
      this.agreements = res.map((agreement: IAgreement) => agreement.title);
    }
  }
  destroyed() {
    document.removeEventListener('popstate', this.backChange);
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/helps.scss';
@import '@/style/animate.scss';
.switch {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
}
.trial-page {
  width: 100%;
  height: 100%;
}
.comp-wrapper {
  position: relative;
}

@include pulse;
.animate-pluse {
  animation-name: pulse;
  animation-duration: 700ms;
  animation-iteration-count: infinite;
}
</style>
